import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dependency
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditDelayMessage = ({
  areChildObjectsInAction,
  delayEnrollmentCount,
  flowObjectTypeId,
  isChangingDay,
  isChangingDayTime,
  isDecreasing,
  isDeleting,
  isIncreasing,
  isDelayActionType
}) => {
  if (isIncreasing) {
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.increaseMessage_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: delayEnrollmentCount
      }
    });
  } else if (isDecreasing) {
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.decreaseMessage_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: delayEnrollmentCount
      }
    });
  } else if (isChangingDay && isChangingDayTime) {
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.changeDayAndDayTime_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: delayEnrollmentCount
      }
    });
  } else if (isChangingDay) {
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.changeDay_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: delayEnrollmentCount
      }
    });
  } else if (isChangingDayTime) {
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.changeDayTime_cob",
      objectTypeId: flowObjectTypeId,
      options: {
        count: delayEnrollmentCount
      }
    });
  } else if (isDeleting) {
    if (areChildObjectsInAction) {
      return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.deletionMessage.child-objects-in-action_cob",
        objectTypeId: flowObjectTypeId,
        options: {
          count: delayEnrollmentCount
        }
      });
    } else if (isDelayActionType) {
      return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.deletionMessage.delay_cob",
        objectTypeId: flowObjectTypeId,
        options: {
          count: delayEnrollmentCount
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-action-features.action-features.delay.edit-delay-modal.deletionMessage.nonDelay_cob",
        objectTypeId: flowObjectTypeId,
        options: {
          count: delayEnrollmentCount
        }
      });
    }
  }
  return null;
};
const EditDelayModal = ({
  areChildObjectsInAction,
  onConfirm,
  onDismiss,
  isDeleting,
  delayEnrollmentCount,
  flowObjectTypeId,
  isDelayActionType,
  isIncreasing = false,
  isDecreasing = false,
  isChangingDay = false,
  isChangingDayTime = false
}) => {
  if (!delayEnrollmentCount || !isIncreasing && !isDecreasing && !isChangingDay && !isChangingDayTime && !isDeleting) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onDismiss
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-action-features.action-features.delay.edit-delay-modal.header"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(EditDelayMessage, {
        areChildObjectsInAction: areChildObjectsInAction,
        isIncreasing: isIncreasing,
        isDecreasing: isDecreasing,
        isChangingDay: isChangingDay,
        isChangingDayTime: isChangingDayTime,
        isDeleting: isDeleting,
        delayEnrollmentCount: delayEnrollmentCount,
        flowObjectTypeId: flowObjectTypeId,
        isDelayActionType: isDelayActionType
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: onConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-action-features.action-features.delay.edit-delay-modal.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onDismiss,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-action-features.action-features.delay.edit-delay-modal.dismiss"
        })
      })]
    })]
  });
};
EditDelayModal.propTypes = {
  areChildObjectsInAction: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  isIncreasing: PropTypes.bool,
  isDecreasing: PropTypes.bool,
  isChangingDay: PropTypes.bool,
  isChangingDayTime: PropTypes.bool,
  isDeleting: PropTypes.bool,
  isDelayActionType: PropTypes.bool,
  delayEnrollmentCount: PropTypes.number,
  flowObjectTypeId: ObjectTypeIdType
};
export default EditDelayModal;